import { HierarchyContextProps } from "../interface";

/**
 * Checks single replacements for validation issues and updates save blockers.
 *
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with validation warnings
 */
export const hcr_checkSingles = (state: HierarchyContextProps): HierarchyContextProps => {
  if (state.hierarchy) {
    const warnings = new Set<{ airid: string; warningText: string }>();
    state.hierarchy.singles.forEach((single) => {
      if (single.oldText === "") {
        warnings.add({ airid: single.airid, warningText: "Missing text will be ignored" });
      }
      if (state.hierarchy!.singles.filter((o) => o.oldText === single.oldText).length > 1) {
        warnings.add({
          airid: single.airid,
          warningText: "Duplicates will cause unpredictable results",
        });
      }
      if (
        single.oldText !== "" &&
        single.newText.lines
          .map((l) => l.textBlocks.map((b) => b.text).join(""))
          .join("\n")
          .includes(single.oldText)
      ) {
        warnings.add({
          airid: single.airid,
          warningText: "New text cannot contain the original text",
        });
      }
    });
    return {
      ...state,
      saveBlockers: {
        ...state.saveBlockers,
        singles: warnings,
      },
    };
  }
  return state;
};
